import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chem-card" }
const _hoisted_2 = { class: "flex item-name-area" }
const _hoisted_3 = { class: "product-name flex items-center" }
const _hoisted_4 = { class: "q-mb-none" }
const _hoisted_5 = { class: "img-container emphable-img" }
const _hoisted_6 = { class: "supplier-bottoms-area flex items-end justify-between mt-1" }
const _hoisted_7 = { class: "supplier-num-area flex items-end justify-between" }
const _hoisted_8 = {
  key: 0,
  class: "tag-area w-100 text-right"
}

import { computed } from 'vue';
import AtomImage from '../images/AtomImage.vue';

// 検索結果interface
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

interface Props {
  // 検索結果
  result: Result;
  // チェック値
  checkValues: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChemCard',
  props: {
    result: {},
    checkValues: {}
  },
  emits: ["changeCheck", "onDetail"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// チェックボックス
const resultDetailCheckbox = computed({
  get: () => props.checkValues,
  set: (value) => {
    emit('changeCheck', value);
  },
});

// 詳細ボタン押下
const onDetail = (attoId: string) => {
  emit('onDetail', attoId);
};

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_checkbox, {
        modelValue: resultDetailCheckbox.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resultDetailCheckbox).value = $event)),
        color: "primary",
        val: props.result.atto_id
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(props.result.atto_id), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "val"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(AtomImage, {
        exatoms: props.result.structure
      }, null, 8, ["exatoms"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_q_btn, {
        color: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onDetail(props.result.atto_id)))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("詳細")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        (props.result.order_count === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[3] || (_cache[3] = [
              _createElementVNode("p", { class: "q-mb-none" }, "要問合せ", -1)
            ])))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "supplier-label q-mb-non" }, "取扱い数", -1)),
        _createElementVNode("p", {
          class: _normalizeClass(
            'q-mb-none supplier-number ' +
            (props.result.atto_supplier_count === 0 ? 'supplier-none' : '')
          )
        }, _toDisplayString(props.result.atto_supplier_count), 3)
      ])
    ])
  ]))
}
}

})